/** 日ごとの天候の性格（docs/04_world-and-weather.md 7 章） */
export interface DayProfile {
  name: string;
  wind: { fromDeg: [number, number]; kmhAt2000m: [number, number]; drift: number };
  thermal: {
    startHour: [number, number];
    peakHour: [number, number];
    endHour: [number, number];
    maxClimbMs: [number, number];
  };
  cloudBase: { startM: [number, number]; maxM: [number, number] };
  cumulusRatio: number;
  storm: {
    chance: number;
    onsetHour: [number, number];
    leadMin: [number, number];
    cells: [number, number];
    /** 成熟した雷雲の寿命（分） */
    lifeMin: [number, number];
  };
  /** 予報に添える一般的なヒント */
  hint: string;
}

export const DAY_PROFILES: DayProfile[] = [
  {
    name: '安定した好天',
    wind: { fromDeg: [250, 290], kmhAt2000m: [10, 20], drift: 0.25 },
    thermal: { startHour: [9.5, 10.5], peakHour: [13, 15], endHour: [18, 19], maxClimbMs: [3.0, 3.8] },
    cloudBase: { startM: [2600, 2900], maxM: [3600, 3900] },
    cumulusRatio: 0.8,
    storm: { chance: 0.15, onsetHour: [17, 19], leadMin: [60, 90], cells: [1, 1], lifeMin: [60, 100] },
    hint: '午前は東向きの斜面、午後は西向きの斜面が有利。昼過ぎがサーマルの最盛期',
  },
  {
    name: '不安定',
    wind: { fromDeg: [200, 240], kmhAt2000m: [8, 20], drift: 0.35 },
    thermal: { startHour: [9, 9.75], peakHour: [12, 14], endHour: [17.5, 18.5], maxClimbMs: [3.5, 4.3] },
    cloudBase: { startM: [2400, 2700], maxM: [3200, 3500] },
    cumulusRatio: 0.9,
    storm: { chance: 0.6, onsetHour: [14, 16], leadMin: [60, 90], cells: [1, 2], lifeMin: [80, 120] },
    hint: 'サーマルは早く立つが、午後は雷雨に注意。積雲が高く育ち始めたら要警戒',
  },
];
